module.exports = __webpack_public_path__ + "static/img/fei1.1126d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fei1.jpg
// module id = nnLi
// module chunks = 1